import { Action } from '@ngrx/store';

export const SET_PERSONNEL_STATUS_ON_CLIENT = 'SET_PERSONNEL_STATUS_ON_CLIENT';
export const SET_PERSONNEL_STATUS_ON_SERVER = 'SET_PERSONNEL_STATUS_ON_SERVER';
export const GET_AVAILABLE_STATUSES = 'GET_AVAILABLE_STATUSES';
export const UPD_AVAILABLE_STATUSES = 'UPD_AVAILABLE_STATUSES';

export class SetPersonnelStatusOnClientAction implements Action {
  public readonly type = SET_PERSONNEL_STATUS_ON_CLIENT;

  constructor(public payload: { status: string }) {}
}

export class SetPersonnelStatusOnServerAction implements Action {
  public readonly type = SET_PERSONNEL_STATUS_ON_SERVER;

  constructor(public payload: { status: string }) {}
}

export class GetAvailableStatusesAction implements Action {
  public readonly type = GET_AVAILABLE_STATUSES;
}

export class UpdAvailableStatusesAction implements Action {
  public readonly type = UPD_AVAILABLE_STATUSES;

  constructor(public payload: { List: { status: string }[] }) {}
}

export type Actions =
  | SetPersonnelStatusOnClientAction
  | SetPersonnelStatusOnServerAction
  | GetAvailableStatusesAction
  | UpdAvailableStatusesAction;
